export enum FeatureNames {
  KEYWORD_REVIEW_CROSS_ANALYSIS = "keyword_review_cross_analysis"
}
